export const ErrorAlert = ({ message }) => {
  return (
    <div className="bg-danger bg-opacity-20 text-danger border border-danger p-2 rounded">
      <i className="ri-error-warning-fill me-2"></i>
      {message}
    </div>
  );
};
